module.exports = __webpack_public_path__ + "static/media-person-6d67b9e50334cc0731ff50a8d5502bea.jpg";